import faqService from "../../services/faqService/service";
import faqModel from "../../models/faqModel/model";

export default {
    async fetchFaqs(search,page, limit, company) {
        try {
            const sanitizedSearch = search && search.trim() !== '' ? search : null;
            const { data, headers } = await faqService.getFaqs(sanitizedSearch, page, limit, company);
            return {
                data: data.map(faq => new faqModel(faq)),
                total: parseInt(headers['x-total-count'], 10), // Header untuk total data
            };
        } catch (error) {
            console.error('Error fetching faqs:', error);
            throw error;
        }
    },
    async totalAllFaqs(search, company) {
        try {
            const sanitizedSearch = search && search.trim() !== '' ? search : null;
            return await faqService.totalAllFaqs(sanitizedSearch, company);
        } catch (error) {
            console.error('Error fetching faqs:', error);
            throw error;
        }
    },

    async addFaq(faq) {
        try {
            return await faqService.addFaq(faq);
        } catch (error) {
            console.error('Error adding faq:', error);
            throw error;
        }
    },

    async updateFaq(faq) {
        try {
            return await faqService.updateFaq(faq);
        } catch (error) {
            console.error('Error updating faq:', error);
            throw error;
        }
    },
    async deleteFaq(faqId) {
        try {
            return await faqService.deleteFaq(faqId);
        } catch (error) {
            console.error('Error deleting faq:', error);
            throw error;
        }
    }
};